import React, {useMemo} from 'react';
import {Link} from 'react-router-dom';
import {MaterialReactTable} from 'material-react-table';
import Moment from 'react-moment';
import ClaimStatusOld from './claim-status_old';

const ClaimsTableOld = ({claims}) => {
  const columns = useMemo(
      () => [
        {accessorKey: 'fault_report_no', header: '#FR'},
        {accessorKey: 'date_of_visit', header: 'Date'},
        {accessorKey: 'status_label', header: 'Claim Status'},
        {accessorKey: 'actions', header: 'Actions'},
      ],
      [],
  );

  const data = useMemo(
      () =>
        claims.map((element) => ({
          fault_report_no: element.fault_report_no,
          date_of_visit: <Moment format="DD-MM-YYYY">{element.date_of_visit}</Moment>,
          status_label: <ClaimStatusOld claim={element} />,
          actions: (
            <div>
              <Link
                to={{
                  pathname: '/claim/' + element.id,
                  state: {printerId: element.id},
                }}
                className="mr-3 text-primary"
              >
                <button className="btn btn-primary btn-sm waves-effect waves-light">
                View Details
                </button>
              </Link>
            </div>
          ),
        })),
      [claims],
  );

  return (
    <div>
      <h4 className="card-title">Claims Overview</h4>
      <MaterialReactTable
        columns={columns}
        data={data}
        enablePagination
        enableSorting
        enableBottomToolbar
        enableTopToolbar={false}
        enableColumnFilters={false}
        enableRowSelection={false}
      />
    </div>
  );
};

export default ClaimsTableOld;
